export const colorTheme = {
    selectedTableStatsHeader: 'rgb(209 209 209)',
    selectedTableStats: '#8d8d8d'
}

